export default {
    props: {
        specialities: { type: Array, required: true },
    },

    methods: {
        hasNoSubSpecialities(data) {
            return this.subSpecialities(data).length === 0
        },

        subSpecialities({ specialityId }) {
            const speciality = this.specialities.find((speciality) => speciality.value === specialityId)

            if (!speciality) {
                return []
            }

            return (speciality.data.subSpecialities || []).map((option) => ({
                value: option.id,
                label: option.name,
            }))
        },
    },
}
